/* eslint-disable react/no-unused-prop-types */
import React from 'react';
function TableCellImage(props) {
    const { value } = props || {};
    return (React.createElement("div", { style: { width: '60px' } },
        React.createElement("img", { style: { width: '60px' }, src: value, alt: '' })));
}
TableCellImage.displayName = 'TableCellImage';
export { TableCellImage };
